import { render, staticRenderFns } from "./GifMessage.vue?vue&type=template&id=1a418604&scoped=true&"
import script from "./GifMessage.vue?vue&type=script&lang=js&"
export * from "./GifMessage.vue?vue&type=script&lang=js&"
import style0 from "./GifMessage.vue?vue&type=style&index=0&id=1a418604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a418604",
  null
  
)

export default component.exports